import React from 'react';
import classNames from 'classnames';
import useDarkMode from '../../Hooks/useDarkMode';

const Badge = ({
  children,
  className,
  color = 'primary',
  shadow,
  rounded,
  isLight,
  ...props
}) => {
  const { darkModeStatus } = useDarkMode();

  return (
    <span
      className={classNames(
        'badge',
        {
          [`bg-${color}`]: !isLight,
          [`bg-l${darkModeStatus ? 'o25' : '10'}-${color}`]: isLight,
          [`text-${color}`]: isLight,
          [`shadow${shadow !== 'default' ? `-${shadow}` : ''}`]: !!shadow,
          [`rounded${rounded !== 'default' ? `-${rounded}` : ''}`]: rounded,
          'rounded-0':
            rounded === 'bottom' ||
            rounded === 'top' ||
            rounded === 'end' ||
            rounded === 'start' ||
            rounded === 0,
        },
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
};

export default Badge;
